const { API_URL = 'https://api-jobs.buildstaging.com' } = process.env

export const getConfig = (payload) => ({
  baseURL: `${API_URL}/api/v2`,
  headers: {
    'Content-Type': 'application/json',
  },
  endpoints: {
    jobs: `/jobs`,
    offices: `/offices`,
  },
  driver: 'axios',
})
